import { RestfulAccessorProvider } from "@core/data-access/restful/restful-accessor.provider";

let name = "qp-core-accessor";

angular.module(name, [])
    .provider({
        $accessor: RestfulAccessorProvider,
    })

export { name }
